import React, { Component } from 'react';
import styled from 'styled-components';

const Base = styled.div`
  text-align: left;
  a {
    cursor: pointer;
    height: 17.5px;
    width: 17.5px;
    margin-left: 66px;
    &:first-child {
      margin-left: 0;
    }
  }
  a:visited {
    color: #dee6eb !important;
  }
`;

const Desktop = styled(Base)``;

const Mobile = styled(Base)`
  margin: 20px 0;
  a {
    margin-left: 24px;
    &:first-child {
      margin-left: 0;
    }
  }
`;

type Props = {
  isMobile?: boolean;
};

class SocialMedia extends Component<Props> {
  render() {
    return (
      <span>
        {this.props.isMobile ? (
          <Mobile>
            <a href="https://www.facebook.com/solvhealth">
              {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message */}
              <img src="/images/icons/social/Icon-Facebook.svg" type="social" alt="fb" />
            </a>

            <a href="https://twitter.com/solvhealth">
              {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message */}
              <img src="/images/icons/social/Icon-Twitter.svg" type="social" alt="twitter" />
            </a>

            <a href="https://www.instagram.com/solvhealth">
              {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message */}
              <img type="social" alt="instagram" src="/images/icons/social/Icon-Instagram.svg" />
            </a>
          </Mobile>
        ) : (
          <Desktop>
            <a href="https://www.facebook.com/solvhealth">
              {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message */}
              <img src="/images/icons/social/Icon-Facebook.svg" type="social" alt="fb" />
            </a>

            <a href="https://twitter.com/solvhealth">
              {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message */}
              <img src="/images/icons/social/Icon-Twitter.svg" type="social" alt="twitter" />
            </a>

            <a href="https://www.instagram.com/solvhealth">
              {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message */}
              <img type="social" alt="instagram" src="/images/icons/social/Icon-Instagram.svg" />
            </a>
          </Desktop>
        )}
      </span>
    );
  }
}

export default SocialMedia;
